module.exports = __webpack_public_path__ + "static/SearchVideoES-c31d572fc1f4254a4465e8677c0d5cec.mp4";